import { render, staticRenderFns } from "./VuesticMediumEditor.vue?vue&type=template&id=23e127f6"
import script from "./VuesticMediumEditor.vue?vue&type=script&lang=js"
export * from "./VuesticMediumEditor.vue?vue&type=script&lang=js"
import style0 from "./VuesticMediumEditor.vue?vue&type=style&index=0&id=23e127f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports